import MasterCrudPage from "../../components/MasterCrudPage";
import { locationTypeApi } from "../../api/masterApi";

export default function LocationType() {
  return (
    <MasterCrudPage
      title="Location Type Master"
      description="Define location type categories (Country, State, City)."
      idKey="location_type_id"
      api={locationTypeApi}
      listLabel="location types"
      useJson
      fields={[
        {
          name: "location_type_name",
          label: "Location Type",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. Country, State, City, Region",
        },
      ]}
      columns={[
        { key: "location_type_id", label: "Location Type" },
        { key: "location_type_name", label: "Location Type" },
      ]}
    />
  );
}
